module.exports = __webpack_public_path__ + "static/img/theme-set.cde0e50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/theme-set.jpg
// module id = kIxN
// module chunks = 0